export default {
  cancelled: 0,
  initialize: 1,
  planning: 2,
  processed: 3,
  sent: 4,
};
